import { saveAs } from "file-saver";

const escapeCsvCell = (value) => {
  const str = String(value ?? "");
  if (/[",\n\r]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
};

const escapeXml = (value) =>
  String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&apos;");

const toSafeXmlTag = (name) => {
  const tag = String(name || "table")
    .trim()
    .replace(/[^\w-]+/g, "_")
    .replace(/^_+|_+$/g, "");

  return tag && /^[A-Za-z_]/.test(tag) ? tag : `table_${tag || "export"}`;
};

export const downloadTableAsCsv = (matrix, filename) => {
  const lines = [
    matrix.headers.map(escapeCsvCell).join(","),
    ...matrix.rows.map((row) => row.map(escapeCsvCell).join(",")),
  ];

  const blob = new Blob([`\uFEFF${lines.join("\r\n")}`], {
    type: "text/csv;charset=utf-8;",
  });

  saveAs(blob, `${filename}.csv`);
};

export const downloadTableAsJson = (matrix, filename, metadata = {}) => {
  const records = matrix.rows.map((row) => {
    const record = {};
    matrix.headers.forEach((header, index) => {
      record[header] = row[index];
    });
    return record;
  });

  const payload = {
    exportedAt: new Date().toISOString(),
    ...metadata,
    columns: matrix.headers,
    rowCount: records.length,
    data: records,
  };

  const blob = new Blob([JSON.stringify(payload, null, 2)], {
    type: "application/json;charset=utf-8;",
  });

  saveAs(blob, `${filename}.json`);
};

export const downloadTableAsXml = (matrix, filename, metadata = {}) => {
  const rootTag = toSafeXmlTag(metadata.rootName || filename);
  const headerXml = matrix.headers
    .map(
      (header, index) =>
        `      <column index="${index + 1}">${escapeXml(header)}</column>`
    )
    .join("\n");

  const rowsXml = matrix.rows
    .map((row, rowIndex) => {
      const cells = row
        .map(
          (cell, colIndex) =>
            `        <cell column="${escapeXml(matrix.headers[colIndex])}">${escapeXml(cell)}</cell>`
        )
        .join("\n");

      return `      <row index="${rowIndex + 1}">\n${cells}\n      </row>`;
    })
    .join("\n");

  const metaXml = Object.entries(metadata)
    .filter(([key]) => key !== "rootName")
    .map(
      ([key, value]) =>
        `    <${key}>${escapeXml(value)}</${key}>`
    )
    .join("\n");

  const xml = `<?xml version="1.0" encoding="UTF-8"?>
<${rootTag}>
  <metadata>
${metaXml}
    <exportedAt>${escapeXml(new Date().toISOString())}</exportedAt>
  </metadata>
  <headers>
${headerXml}
  </headers>
  <rows count="${matrix.rows.length}">
${rowsXml}
  </rows>
</${rootTag}>`;

  const blob = new Blob([xml], { type: "application/xml;charset=utf-8;" });
  saveAs(blob, `${filename}.xml`);
};
